<p-panel class="our-form-background">
  <ng-template pTemplate="header" class="eca-secondary-bg" style="color: white">
    <div class="row" style="padding: 5px !important; width:100% !important;">
      <div class="col-auto d-flex align-items-center" style="padding-right: 0 !important;">
        <div class="d-flex align-items-center">
          <h3 style="margin-bottom: 0 !important;" class="h3-relative-font-size">
            <span style="margin-left: 5px;"><fa-icon [icon]="['fas', 'user']"> </fa-icon> <span class="hide-on-small-screens"> Operative -</span> {{ operative?.firstName }} {{ operative?.lastName}}</span>
          </h3>
        </div>
      </div>
      <div class="col pull-right">
        <app-eca-ghost-btn class="card-action-icon float-right" btnIcon="question-circle" btnType="warning" (btnClicked)="openOperativeDetailsHelp()">
        </app-eca-ghost-btn>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <div class="container-fluid" style="margin-top:20px !important;">
      <div class="row">
        <div class="col-12">
          <app-detail-container #opDetailsContainerComponent [containerHeader]="opDetailsContainerHeader"
                                [collapsedContainerHeader]="opDetailsCollapsedContainerHeader"
                                [containerHeaderAction]="opDetailsAction" [pullRightOnMobile]="false">
            <ng-template #opDetailsContainerHeader>
              Operative Details
            </ng-template>
            <ng-template #opDetailsCollapsedContainerHeader>
              Operative Details <span class="hide-on-small-screens">- {{operative.getFullName()}}</span>
            </ng-template>
            <ng-template #opDetailsAction>
              <app-eca-ghost-btn class="title-action-button float-right" [ngClass]="opDetailsContainerComponent.isCollapsed ? 'hide-on-small-screens': ''" btnText="Edit" btnIcon="edit" btnType="primary"
                                 *ngIf="!editingOperativeDetails && !isNewOperative && loggedInUser?.operativeOperations?.canUpdate && !editingCurrentEngagement"
                                 [disable]='savingOperativeDetails'
                                 (btnClicked)="editOperativeDetails()"></app-eca-ghost-btn>
              <span class="float-right" *ngIf="editingOperativeDetails && !isNewOperative">
                <app-eca-ghost-btn btnText="Save" btnIcon="save" btnType="success"
                                   [disable]='savingOperativeDetails'
                                   (btnClicked)="saveOperativeDetails()"></app-eca-ghost-btn>
                <app-eca-ghost-btn btnText="Cancel" btnIcon="times" btnType="danger"
                                   [disable]='savingOperativeDetails'
                                   (btnClicked)="cancelEditOperativeDetails()"></app-eca-ghost-btn>
              </span>
            </ng-template>
            <div *ngIf="savingOperativeDetails" class="text-center">
              <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x"
                               primaryColor="darkgreen" secondaryColor="green"></fa-duotone-icon>
            </div>
            <div *ngIf="!savingOperativeDetails">
              <div class="row">
                <div class="col-md-1 p-image-div">
                  <app-eca-image-viewer [imageSrc]="operative.image"
                                        [isSrcEncoded]="true"
                                        [enableEdit]="editingOperativeDetails"
                                        (imageOutput)="newOperativeImage($event)"></app-eca-image-viewer>
                </div>
                <div class="col-md-11">
                  <div class="row">
                    <!--First Name-->
                    <div class="col-lg-4  col-md-6 col-sm-12">
                      <app-eca-input label="First Name" [isRequired]="true" [isReadOnly]="!editingOperativeDetails" [controlId]="'ctrlOperativeFirstName'"
                                     [(value)]="operative.firstName"></app-eca-input>
                    </div>
                    <!--Middle Initial-->
                    <div class="col-lg-3  col-md-6 col-sm-12">
                      <app-eca-input label="Middle Initials" [isRequired]="false" [controlId]="'ctrlOperativeMiddleInitials'"
                                     [isReadOnly]="!editingOperativeDetails"
                                     [(value)]="operative.middleInitials">
                      </app-eca-input>
                    </div>
                    <!--Last Name-->
                    <div class="col-lg-5  col-md-6 col-sm-12">
                      <app-eca-input label="Last Name" [isRequired]="false" [controlId]="'ctrlOperativeLastName'"
                                     [isReadOnly]="!editingOperativeDetails"
                                     [(value)]="operative.lastName">
                      </app-eca-input>
                    </div>
                  </div>

                  <div class="row">
                    <!--Reference Numbers-->
                    <div class="col-xl-4 col-md-6 col-sm-12">
                      <app-eca-input label="Reference/Card Numbers" [isRequired]="false" [controlId]="'ctrlOperativeReferenceNumber'"
                                     [isReadOnly]="!editingOperativeDetails"
                                     [(value)]="operative.referenceNumbers"
                                     popoverText="You can store card numbers or any other reference number here to help identify the operative in your records">
                      </app-eca-input>
                    </div>
                    <!--Phone Number-->
                    <div class="col-xl-3 col-md-6 col-sm-12">
                      <app-eca-input label="Phone Number" [isRequired]="false" [controlId]="'ctrlOperativePhone'"
                                     [isReadOnly]="!editingOperativeDetails" [inputType]="'number'"
                                     [(value)]="operative.phoneNumber">
                      </app-eca-input>
                    </div>
                    <!--Email-->
                    <div class="col-xl-5 col-md-6 col-sm-12">
                      <app-eca-input label="Email Address" [inputType]="'email'" [controlId]="'ctrlOperativeEmail'"
                                     [isValid]="validateEmail(operative.emailAddress)"
                                     [isRequired]="true"
                                     [isReadOnly]="!editingOperativeDetails"
                                     [(value)]="operative.emailAddress">
                      </app-eca-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </app-detail-container>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-detail-container #opRiskContainer [collapsedContainerHeader]="opRoleCollapsedContainerHeader"
                                [containerClass]="operative.getRiskClass()+'-bg'"
                                [containerHeader]="opRoleContainerHeader" [containerHeaderAction]="opRoleHeaderAction">
            <ng-template #opRoleContainerHeader>
              Current Role <span *ngIf="!isQsRole && showRoleBadge && !editingCurrentEngagement" style="margin-left: 20px" class="badge badge-pill text-wrap role-badge"
                                 [ngClass]="operative.getRiskBadgeClass()">{{ operative.getSupervisionRequirement() }}</span>
              <span *ngIf="isQsRole && !editingCurrentEngagement" style="margin-left: 20px" class="badge badge-pill  text-wrap">Qualified Supervisor - no additional Assessment required</span>
            </ng-template>
            <ng-template #opRoleCollapsedContainerHeader>
              <!--  TODO Add role summaries for collapsed container-->
              Current Role <span *ngIf="!isQsRole  && showRoleBadge && !editingCurrentEngagement" style="margin-left: 20px" class="badge badge-pill text-wrap role-badge"
                                 [ngClass]="operative.getRiskBadgeClass()">{{ operative.getSupervisionRequirement() }}</span>
              <span *ngIf="isQsRole && !editingCurrentEngagement " style="margin-left: 20px" class="badge badge-pill  text-wrap">Qualified Supervisor - no additional Assessment required</span>

            </ng-template>

            <ng-template #opRoleHeaderAction>
              <span class="float-right">
                <span *ngIf="!isNewOperative && !editingCurrentEngagement && !editingOperativeDetails && loggedInUser?.operativeOperations?.canUpdate">
                  <app-eca-ghost-btn btnText="Add" btnIcon="plus-circle" btnType="success"
                                     [disable]='savingEngagementDetails'
                                     (btnClicked)="addNewEngagement()"></app-eca-ghost-btn>
                  <app-eca-ghost-btn btnText="Edit" btnIcon="edit" btnType="primary"
                                     [disable]='savingEngagementDetails'
                                     (btnClicked)="editCurrentEngagement()"></app-eca-ghost-btn>
                </span>
                <span *ngIf="!isNewOperative && editingCurrentEngagement">
                  <app-eca-ghost-btn btnText="Save" btnIcon="save" btnType="success"
                                     [disable]='savingEngagementDetails'
                                     (btnClicked)="saveCurrentEngagement()"></app-eca-ghost-btn>
                  <app-eca-ghost-btn btnText="Cancel" btnIcon="times" btnType="danger"
                                     [disable]='savingEngagementDetails'
                                     (btnClicked)="cancelEditCurrentEngagement()"></app-eca-ghost-btn>
                </span>
                <app-eca-ghost-btn *ngIf="!editingOperativeDetails && !editingCurrentEngagement && !isNonElectricalJobRole && tempEngagementRole.operativeTypeId != '9e693556-8c16-44a2-b1e4-2c8d18b081ad'"
                                   btnText="EAS" btnIcon="bolt" btnType="warning"
                                   (btnClicked)="openRiskHelp()"></app-eca-ghost-btn>

                <app-eca-ghost-btn *ngIf="!editingOperativeDetails && !editingCurrentEngagement && !isNonElectricalJobRole && tempEngagementRole.operativeTypeId == '9e693556-8c16-44a2-b1e4-2c8d18b081ad'"
                                   btnText="Risk" btnIcon="bolt" btnType="warning"
                                   (btnClicked)="openRiskHelp()"></app-eca-ghost-btn>
              </span>
            </ng-template>
            <div class="row" *ngIf="!isNewOperative && editingCurrentEngagement">
              <div class="col">
                <div class="alert alert-danger">
                  <p>
                    Please note that you are editing the current operative engagement. This will overwrite the
                    operatives information for the selected period.
                  </p>
                  <p>
                    If the operative is changing to a new role or job, you should cancel your changes and create a New
                    engagement for the new period of work
                  </p>
                </div>
              </div>
            </div>
            <div *ngIf="savingEngagementDetails || loadingCurrentEngagement" class="text-center">
              <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x"
                               primaryColor="darkgreen" secondaryColor="green"></fa-duotone-icon>
            </div>
            <div *ngIf="!savingEngagementDetails && !loadingCurrentEngagement">
              <div class="row">
                <!--Business Units-->
                <div class="col-xl-4 col-md-4 col-sm-12">
                  <app-eca-select [controlId]="'ctrlBusinessUnit'"
                                  [options]="allBusinessUnits" [(selectedId)]="selectedBusinessUnitId" (selectedIdChange)="updateBusinessUnit($event,true)"
                                  [isRequired]="false"
                                  label="Business Unit"
                                  [isReadOnly]="!editingCurrentEngagement || allBusinessUnits?.length < 1"
                                  [popoverText]=businessUnitHelpText>
                  </app-eca-select>
                </div>
                <!--Operative Type-->
                <div class="col-xl-4 col-md-4 col-sm-12">
                  <app-eca-select [controlId]="'ctrlOperativeType'"
                                  [options]="allOperativeTypes" [(selectedId)]="selectedOperativeTypeId" (selectedIdChange)="updateJobTitles($event,true)"
                                  [isRequired]="true"
                                  label="Operative Type"
                                  [isReadOnly]="!editingCurrentEngagement"
                                  popoverText="Select the Type that best suits the Operatives current role">
                  </app-eca-select>
                </div>               
                <!--Job Title-->
                <div class="col-xl-4 col-md-4 col-sm-12">
                  <app-eca-select *ngIf="tempEngagementRole.operativeTypeId != '4eff2451-6793-4590-82c1-fc189dc47859'"
                                  [controlId]="'ctrlJobTitle'"
                                  [options]="filteredJobTitles" [(selectedId)]="selectedJobTitleId" (selectedIdChange)="updateJobLevel($event,true)"
                                  [isRequired]="true"
                                  label="Job Role" [showUpdateMessage]="showJobTitleUpdate"
                                  [updateMessage]="'Updated after Operative Type change.'"
                                  [isReadOnly]="!editingCurrentEngagement"
                                  popoverText="Choose the Job Role that best fits the operative's role">
                  </app-eca-select>
                  <app-eca-select *ngIf="tempEngagementRole.operativeTypeId == '4eff2451-6793-4590-82c1-fc189dc47859'"
                                  [controlId]="'ctrlCompanyJobTitle'"
                                  [options]="allCompanyJobTitles" [(selectedId)]="selectedCompanyJobTitleId" (selectedIdChange)="updateJobLevel($event,true)"
                                  [isRequired]="true"
                                  label="Job Role for Non electrical" [showUpdateMessage]="showJobTitleUpdate"
                                  [updateMessage]="'Updated after Operative Type change.'"
                                  [isReadOnly]="!editingCurrentEngagement"
                                  popoverText="Choose the Job Role that best fits the operative's role">
                  </app-eca-select>
                </div>
              </div>
              <div class="row">
                <!--Job Level-->
                <div class="col-xl-4 col-md-4 col-sm-12">
                  <app-eca-select [controlId]="'ctrlJobLevel'"
                                  [options]="filteredJobLevels" [(selectedId)]="selectedJobLevelId" (selectedIdChange)="updateRisk($event)"
                                  [isRequired]="true"
                                  label="Job Level" [showUpdateMessage]="showJobLevelUpdate"
                                  [updateMessage]="'Updated after Job Role change.'"
                                  [isReadOnly]="!editingCurrentEngagement || isNonElectricalJobRole || isQsRole"
                                  popoverText="Select the level the operative is currently working at">
                  </app-eca-select>
                </div>
                <!--Job Risk-->
                <div class="col-xl-8 col-md-8 col-sm-12">
                  <app-eca-select [controlId]="'ctrlJobRisk'"
                                  [options]="filteredRisks" [(selectedId)]="selectedRiskId" (selectedIdChange)="updateRiskItself($event)"
                                  [isRequired]="true"
                                  [showUpdateMessage]="showRiskUpdate"
                                  [updateMessage]="'Updated after Job Level change.'"
                                  label="Degree of Risk in the Electrotechnical Work"
                                  [isReadOnly]="!editingCurrentEngagement || isNonElectricalJobRole"
                                  popoverText="The risk is calculated from the Job Level and Job Role but can be overridden">
                  </app-eca-select>
                </div>
              </div>
              <div class="row">
                <!--Start Date-->
                <div class="col-xl-4 col-md-4 col-sm-12">
                  <app-eca-date-picker [isDisabled]="!editingCurrentEngagement"
                                       [controlId]="'ctrlEngagementFrom'"
                                       (dateValueChange)="disableDatesPriorSelected(tempEngagementRole.from)"
                                       [dateValue]="tempEngagementRole.from"
                                       label="Start Date" [isValid]=" !!tempEngagementRole?.from?.dateTime"
                                       [maxDate]="operativeMaxDate"
                                       [isRequired]="true"
                                       validationMessage="Please enter the date selected role is effective from."
                                       popoverText="Please enter the date that these operative details are active from. This could be the work start date for the operative or when they change job role etc.">
                  </app-eca-date-picker>
                </div>
                <!--End Date-->
                <div class="col-xl-4 col-md-4 col-sm-12">
                  <app-eca-date-picker [isDisabled]="!editingCurrentEngagement || tempEngagementRole?.from?.dateTime === null || tempEngagementRole?.from?.dateTime === undefined"
                                       [controlId]="'ctrlOperativeEndDate'"
                                       (dateValueChange)="disableDatesPostSelected(tempEngagementRole.to)"
                                       [dateValue]="tempEngagementRole.to"
                                       [minDate]="operativeMinDate"
                                       label="End Date"
                                       [isRequired]="false"
                                       popoverText="Please enter the date that this change to the operative ends. You may leave this blank to indicate that the current changes are ongoing.">
                  </app-eca-date-picker>
                </div>
                <!--Employment Status-->
                <div class="col-xl-4 col-md-4 col-sm-12">
                  <app-eca-select [controlId]="'ctrlEmploymentStatus'"
                                  [options]="allEmploymentStatuses" [(selectedId)]="selectedEmploymentStatusId"
                                  [isRequired]="true"
                                  label="Employment Status"
                                  [isReadOnly]="!editingCurrentEngagement"
                                  validationMessage="Please select the employment status for the operative."
                                  popoverText="Please select the employment status for the operative.">
                  </app-eca-select>
                </div>
              </div>
            </div>
          </app-detail-container>
        </div>
      </div>
      <div class="row" style="margin-top: 20px" *ngIf="isNewOperative">
        <div class="col eca-green-6-bg p-4">
          <div class="float-right ">
            <button pButton
                    type="button" size="lg"
                    routerLink="/operatives"
                    class="relative waves-light eca-btn eca-btn-transparent"
                    (click)="editCurrentEngagement()">
              Cancel
              <fa-icon [icon]="['far', 'times']" size="lg" style="margin-left: 10px"></fa-icon>
            </button>
            <button pButton
                    type="button" size="lg"
                    class="relative waves-light eca-btn eca-btn-success"
                    (click)="saveNewOperative()">
              Save New Operative

              <fa-icon [icon]="['far', 'save']" size="lg"
                       style="margin-left: 10px">
              </fa-icon>
            </button>

          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid " style="margin-top: 1rem; margin-bottom: 200px; min-height: 400px">
      <div class="row">
        <div class="col">
          <!--<p-tabView #memberTabs [buttonClass]="'nav md-pills pills-jib mb-2 eca-tabs'" [justified]="true"
                      [contentClass]="'card'" *ngIf="!isNewOperative">-->
          <p-tabView #documentTabs [styleClass]="'eca-tabs'">
            <p-tabPanel>
              <ng-template pTemplate="header">
                <i class='fas fa-warehouse'></i>
                <span class="tab-title">Training Records</span>
              </ng-template>
              <div class="row">
                <div class="col-12">
                  <div *ngIf="updatingTrainingRecord" class="text-center">
                    <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x"
                                     primaryColor="darkgreen" secondaryColor="green"></fa-duotone-icon>
                  </div>
                  <div *ngIf="!updatingTrainingRecord">
                    <app-operative-training-records [addButtonText]="'Add New Training Record'"
                                                    [trainingRecords]="operativeTrainingRecords"
                                                    (addNewTrainingClicked)="addNewTrainingRecord()"
                                                    [showRowControllerButtons]="true"
                                                    [allowedOperations]="operativeUpdateOperations"
                                                    (addDocumentClicked)="addTrainingRecordDocument($event)"
                                                    (addObservationClicked)="createTrainingRecordObservation($event)"
                                                    (deleteTrainingRecordClicked)="deleteTrainingRecordClick($event)"
                                                    (trainingRecordId)="setTrainingRecordId($event)"
                                                    [totalCPDHours]="totalCPDHours"
                                                    [trainingTypes]="trainingRecordTypes">
                    </app-operative-training-records>
                  </div>
                </div>
              </div>
            </p-tabPanel>


            <p-tabPanel>
              <ng-template pTemplate="header">
                <i class='fas fa-file'></i>
                <span class="tab-title">Documents</span>
              </ng-template>
              <div class="row">
                <div class="col-12">
                  <div *ngIf="addingOperativeDocuments" class="text-center">
                    <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x"
                                     primaryColor="darkgreen" secondaryColor="green"></fa-duotone-icon>
                  </div>
                  <div *ngIf="!addingOperativeDocuments">
                    <app-operative-details-documents-list [showWarningMessage]="true"
                                                          [showCount]="true"
                                                          [showRowControllerButtons]="true"
                                                          [headerText]="'Operative Documents'"
                                                          [addDocumentButtonText]="'Add New Document '"
                                                          [operativeDocuments]="operativeDocuments"
                                                          [allowedOperations]="operativeUpdateOperations"
                                                          [showTableCaption]="true" (addDocument)="addOperativeDocument()"
                                                          (downloadDocument)="downloadOperativeDocument($event)" (refreshDocumentsRequested)="getOperativeDocuments($event)"
                                                          (viewDocument)="viewOperativeDocument($event)"
                                                          (deleteDocument)="deleteOperativeDocumentClick($event)"
                                                          (editDocument)="editOperativeDocument($event)"
                                                          (addObservationClicked)="createDocumentObservation($event)"
                                                          (openDocument)="openOperativeDocument($event)">

                    </app-operative-details-documents-list>
                  </div>
                </div>
              </div>
            </p-tabPanel>
            <p-tabPanel>
              <ng-template pTemplate="header">
                <i class='fas fa-eye'></i>
                <span class="tab-title">Observations</span>
              </ng-template>
              <div class="row">
                <div class="col-12">
                  <div *ngIf="observationsLoading" class="text-center">
                    <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x"
                                     primaryColor="darkgreen" secondaryColor="green"></fa-duotone-icon>
                  </div>
                  <div *ngIf="!observationsLoading">
                    <app-operative-observations [showWarningMessage]="true" [observations]="operativeObservationsSummary" [companyId]="companyId" [addButtonText]="'Add New Observation'"
                                                [allowedOperations]="operativeUpdateOperations"
                                                (createObservationClicked)="createOrEditObservation(null,  true, 'Add Observation to ', observationType.Operative, operative.firstName + ' ' + operative.lastName, true)"
                                                (viewObservationClicked)="createOrEditObservation($event, false, 'Observation of ' )"
                                                (editObservationClicked)="createOrEditObservation($event, true, 'Observation of ' )">
                    </app-operative-observations>
                  </div>
                </div>
              </div>
            </p-tabPanel>

            <p-tabPanel>
              <ng-template pTemplate="header">
                <i class='fas fa-user'></i>
                <span class="tab-title">Role History</span>
              </ng-template>
              <div class="row">
                <div class="col-12">
                  <app-operative-history [engagementHistory]="engagements" [addButtonText]="'Add New Role'"
                                         (addRoleHistoryRequested)="addNewEngagement()"
                                         (refreshOperativeSuggested)="loadOperative()"
                                         (deleteRoleHistoryRequested)="deleteRoleHistoryClick($event)"
                                         [allowOperations]="loggedInUser?.operativeOperations"
                                         [operative]="operative"
                                         [allJobTitles]="allJobTitles"
                                         [allBusinessUnits]="allBusinessUnits"
                                         [allCompanyJobTitles]="allCompanyJobTitles"
                                         [allJobLevels]="allJobLevels"
                                         [allOperativeTypes]="allOperativeTypes"
                                         [allRisks]="allRisks"
                                         [allEmploymentStatuses]="allEmploymentStatuses"></app-operative-history>
                </div>
              </div>
            </p-tabPanel>
          </p-tabView>
        </div>
      </div>
    </div>
  </ng-template>
</p-panel>
